import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSessionStore } from "stores/userSessionStore";

export const SystemSyncer = () => {
  const location = useLocation();
  const setSystem = useSessionStore((s) => s.setSystem);

  useEffect(() => {
    const isAdminRoute = location.pathname.startsWith("/admin");
    setSystem(isAdminRoute ? "Admin" : "Default");
  }, [location.pathname, setSystem]);

  return null;
};
